import { LAYOUT } from '../constant'
import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from './basic'
import { importRoutes } from '../helper/routeHelper'

const modulesRoute = importRoutes()

export const RootRoute = {
  path: '/',
  name: 'Root',
  component: LAYOUT,
  meta: {
    title: '待办列表',
    affix: true,
    hideChildrenInMenu: true,
    ignoreKeepAlive: false
  },
  children: [
    {
      path: '',
      name: 'TODOS',
      component: () => import('@/views/Todos.vue'),
      meta: {
        title: '待办列表'
      }
    }
  ]
}

export const AccountRoute = {
  path: '/account',
  name: 'Account',
  component: LAYOUT,
  meta: {
    title: '个人中心',
    hideChildrenInMenu: true,
    ignoreKeepAlive: false
  },
  children: [
    {
      path: '',
      name: 'AccountPage',
      component: () => import('@/views/Account.vue'),
      meta: {
        title: '个人信息'
      }
    }
  ]
}

export const LoginRoute = {
  name: 'login',
  path: '/login',
  component: () => import('@/views/Login.vue'),
  meta: {
    auth: false
  }
}

// 基础路由
export const basicRoutes = [
  LoginRoute,
  RootRoute,
  AccountRoute,
  // ...modulesRoute,
  PAGE_NOT_FOUND_ROUTE,
  REDIRECT_ROUTE
]

// 异步路由
export const asyncRoutes = [
  RootRoute,
  AccountRoute,
  // ...modulesRoute,
  PAGE_NOT_FOUND_ROUTE
]
